
const LstCookieConsentConfig = {
    init: function (settings) {
        LstCookieConsentConfig.config = {
            aos: {
                enable: true
            },
            cookieConsentBtn: document.getElementById('cookie-settings-btn')
        };

        LstCookieConsentConfig.setup();
    },

    setup: function () {
        LstCookieConsentConfig.setupCookieConsent();
        LstCookieConsentConfig.registerEventHandlers();
    },

    setupCookieConsent: function () {
        CookieConsent.run({
            categories: {
                necessary: { enabled: true, readOnly: true },
                analytics: {},
                marketing: {}
            },

            page_scripts: true,

            language: {
                default: 'de',
                translations: {
                    de: {
                        consentModal: {
                            title: "Cookie Einstellungen",
                            description: "Wir verwenden Cookies, um Ihnen ein bestmögliches Webseiten-Erlebnis zu bieten. Dazu zählen Cookies, die für den Betrieb der Seite notwendig sind, sowie solche, die zu Statistikzwecken, für Zusatzfunktionen oder zur Anzeige personalisierter Inhalte genutzt werden. Sie können selbst entscheiden, welche Kategorie Sie zulässen möchten. Bitte beachten Sie, dass auf Basis Ihrer Einstellungen womöglich nicht mehr alle Funktionalitäten der Seite zur Verfügung stehen. <a href=\datenschutz\">Datenschutzerklärung lesen</a>",
                            acceptAllBtn: 'Alles akzeptieren',
                            showPreferencesBtn: 'Auswahl einstellen'
                        },
                        preferencesModal: {
                            title: 'Cookie Auswahl einstellen',
                            acceptAllBtn: 'Alles akzeptieren',
                            acceptNecessaryBtn: 'Alles ablehnen',
                            savePreferencesBtn: 'Auswahl speichern',
                            closeIconLabel: 'Auswahl schliessen',
                            sections: [
                                {
                                    title: 'Notwendig',
                                    description: 'Diese Cookies sind zwingend erforderlich um die Webseite zu betreiben und Sicherheitsfunktionen zu ermöglichen.',

                                    linkedCategory: 'necessary'
                                },
                                {
                                    title: 'Statistik',
                                    description: 'Wir erfassen anonymisierte Daten für Statistiken und Analysen, die uns helfen, unsere Webseite und deren Inhalte stetig zu optimieren.',
                                    linkedCategory: 'analytics'
                                },
                                {
                                    title: 'Marketing',
                                    description: 'Marketing-Cookies werden verwendet, um Besuchern auf Webseiten zu folgen. Die Absicht ist, Anzeigen zu zeigen, die relevant und ansprechend für den einzelnen Benutzer sind und daher wertvoller für Publisher und werbetreibende Drittparteien sind.',
                                    linkedCategory: 'marketing'
                                }
                            ]
                        }
                    }
                }
            }
        });
    },

    registerEventHandlers: function () {
        if (LstCookieConsentConfig.config.cookieConsentBtn) {
            LstCookieConsentConfig.config.cookieConsentBtn.addEventListener('click', function() {
                CookieConsent.openSettings();
            });
        }
    }

};

document.addEventListener('DOMContentLoaded', function () {
    LstCookieConsentConfig.init();
});
